import { createColumnHelper } from '@tanstack/react-table';
import type { DistrictBreakdownTableRow } from './dashboard.types';

const columnHelper = createColumnHelper<DistrictBreakdownTableRow>();

export const districtBreakdownTableColumns = [
  columnHelper.accessor('district', {
    header: 'Aldermanic District #',
    size: 80,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor('totalHouseholds', {
    header: 'Total Households',
    size: 120,
    cell: (info) => info.getValue().toLocaleString(),
  }),
  columnHelper.accessor('totalDisbursed', {
    header: 'Total Disbursed ($)',
    size: 160,
    cell: (info) =>
      info.getValue().toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      }),
  }),
];
